import { render, staticRenderFns } from "./new-arrival.vue?vue&type=template&id=9db9792c&"
import script from "./new-arrival.vue?vue&type=script&lang=js&"
export * from "./new-arrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports